import React from "react";
import Lead1 from "../../assets/images/lead1.jpg"
import Lead2 from "../../assets/images/lead2.jpeg"
import Lead3 from "../../assets/images/lead3.JPG"

export default function AboutPageLeadsSection() {
  return (
    <div id="leads" className="w-11/12 md:w-10/12 py-16 dark:text-sky-500">
      <h1 className="text-3xl font-semibold ">GDSC UIT Leads</h1>
      <div className="grid gap-5 md:grid-cols-3 mt-10 h-[900px] lg:h-[700px]">
        <Card
          title="Syed Hamza Hoda"
          subtitle="2022 - 2023"
          img={Lead1}
        />
        <Card
        title="Filza Manzoor"
        subtitle="2021 - 2022"
        img={Lead2} />
        <Card
          title="Raheel Siddiqui"
          subtitle="2020 - 2021"
          img={Lead3}
        />
      </div>
    </div>
  );
}

function Card({ img, title, subtitle }) {
  return (
    <div
      style={{
        backgroundImage: `url(${img})`,
      }}
      className="bg-cover bg-center rounded-3xl relative overflow-hidden"
    >
      <div
        style={{ backgroundImage: "linear-gradient(#0000, #0000, #0009 )" }}
        className="absolute top-0 left-0 h-full w-full"
      >
        <div className="h-full w-full relative">
          <div className="absolute w-full p-5 bottom-0">
            <h1 className="text-2xl font-semibold text-white">{title}</h1>
            <p className="text-gray-100 mt-3">{subtitle}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
